export default __webpack_public_path__ + "static/media/BSOFT.5bf9eb28.png";